import React from 'react';
import PropTypes from 'prop-types';
import Gateways from 'components/widgets/autocompletes/flightGateways';
import RangePicker from 'components/widgets/rangeDateTimePicker';
import ErrorTooltip from 'components/snippets/errorTooltip';
import moment from 'moment';

const FlightRoundTrip = (props) => {
    const {
        legs,
        errors,
        onChange,
        swapLocations,
    } = props;

    const leg = Object.assign({}, legs[0]);

    const selectDeparture = (value, element) => {
        leg.departure = value;
        const newLegs = [leg, ...legs.slice(1)];
        onChange(newLegs, element);
    };

    const selectDestination = (value, element) => {
        leg.destination = value;
        const newLegs = [leg, ...legs.slice(1)];
        onChange(newLegs, element);
    };

    const onDateChange = (startDate, endDate, element) => {
        leg.startDate = startDate;
        leg.endDate = endDate;
        const newLegs = [leg, ...legs.slice(1)];
        onChange(newLegs, element);
    };

    return (
        <>
            <div className="col-12 col-md-12 col-lg-6 going-to">
                <div className="element-container">
                    <div className="row gutter-0">
                        <div className="col">
                            <label className="text-label" htmlFor="flt_departure_roundtrip">From</label>
                            <div className="element-wrapper">
                                <Gateways
                                    id="flt_departure_roundtrip"
                                    placeholder="Select a location"
                                    onSelect={(value) => { selectDeparture(value, `departure-${leg.key}`); }}
                                    value={leg.departure}
                                />
                                {errors && errors[`departure-${leg.key}`] && (
                                    <ErrorTooltip error={{ message: errors[`departure-${leg.key}`], id: 'departure' }} />
                                )}
                            </div>
                            <button type="button" className="remove-focus-btn" />
                        </div>
                        <div className="col">
                            <button type="button" className="btn-unstyled btn-switch border" onClick={() => swapLocations(0)}>
                                <div className="icon-container">
                                    <svg className="icon mt-xl-1 primary-color" width="100%" height="100%" xmlnsXlink="http://www.w3.org/1999/xlink">
                                        <use xlinkHref="/img/icons/icon-defs.svg#icon-half-right-left-arrow" />
                                    </svg>
                                </div>
                            </button>
                            <label className="text-label" htmlFor="flt_destination_roundtrip">To</label>
                            <div>
                                <div className="element-wrapper">
                                    <Gateways
                                        id="flt_destination_roundtrip"
                                        placeholder="Select a location"
                                        onSelect={(value) => { selectDestination(value, `destination-${leg.key}`); }}
                                        value={leg.destination}
                                    />
                                    {errors && errors[`destination-${leg.key}`] && (
                                        <ErrorTooltip error={{ message: errors[`destination-${leg.key}`], id: 'destination' }} />
                                    )}
                                </div>
                                <button type="button" className="remove-focus-btn" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6 col-xxl-3 duration">
                <div className="element-container range-picker-container">
                    <RangePicker
                        startDateId="flt_departureDate"
                        endDateId="flt_returnDate"
                        onDatesChange={(startDate, endDate) => { onDateChange(startDate, endDate, `date-${leg.key}`); }}
                        minDate={2}
                        startDatePlaceholderText="Departure"
                        endDatePlaceholderText="Return"
                        startDate={leg.startDate}
                        endDate={leg.endDate}
                    />
                    {errors && errors[`dates-${leg.key}`] && (
                        <ErrorTooltip error={{ message: errors[`dates-${leg.key}`], id: 'dates' }} />
                    )}
                </div>
            </div>
        </>
    );
};

FlightRoundTrip.propTypes = {
    legs: PropTypes.instanceOf(Array).isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.instanceOf(Object),
    swapLocations: PropTypes.instanceOf(Object).isRequired,
};

FlightRoundTrip.defaultProps = {
    errors: {},
};

export default FlightRoundTrip;
